import { motion } from "framer-motion";
import { GraduationCap, Smartphone, Clock, Palette, Printer, Check } from "lucide-react";
import { Reveal, SectionTitle } from "./motion";

const ITEMS = [
  { icon: GraduationCap, q: "Mas eu não trabalho com educação...", a: "Não precisa! Qualquer pessoa pode montar kits de atividades para revenda." },
  { icon: Smartphone, q: "Nunca vendi nada pela internet...", a: "Não precisa ter experiência! Você pode divulgar seus kits através das redes sociais, sem precisar aparecer em vídeos." },
  { icon: Clock, q: "Não tenho muito tempo...", a: "Você pode preparar e divulgar seus kits no seu horário, sem uma rotina fixa." },
  { icon: Palette, q: "Não sei criar produtos...", a: "As atividades já estão prontas. Você escolhe os materiais e organiza seus kits." },
  { icon: Printer, q: "Vou precisar de impressora?", a: "Não! Os kits são digitais: você envia o arquivo e o cliente imprime em casa." },
];

const Item = ({ it, i }) => (
  <Reveal delay={i * 0.06}>
    <motion.div
      whileHover={{ x: 6 }}
      className="group grid gap-3 border-t border-ink/10 py-7 sm:grid-cols-12 sm:gap-6"
      data-testid={`objection-item-${i}`}
    >
      <span className="font-display text-sm font-bold text-ink/40 sm:col-span-1">0{i + 1}</span>
      <h3 className="flex items-start gap-3 font-display text-xl font-bold leading-tight text-ink sm:col-span-5 sm:text-2xl">
        <it.icon className="mt-1 h-6 w-6 shrink-0 text-rose transition-transform duration-300 group-hover:rotate-12" />
        “{it.q}”
      </h3>
      <p className="flex items-start gap-2 text-base text-ink/75 sm:col-span-6">
        <Check className="mt-1 h-5 w-5 shrink-0 rounded-full bg-mint/15 p-0.5 text-mint" />
        {it.a}
      </p>
    </motion.div>
  </Reveal>
);

export const Objections = () => (
  <section id="duvidas" className="bg-paper py-20 sm:py-28" data-testid="objections-section">
    <div className="mx-auto max-w-6xl px-5">
      <Reveal>
        <SectionTitle className="max-w-3xl text-ink">
          Gostou da ideia? <span className="text-rose">Aqui estão as dúvidas mais comuns:</span>
        </SectionTitle>
      </Reveal>
      <div className="mt-12 border-b border-ink/10">
        {ITEMS.map((it, i) => <Item key={it.q} it={it} i={i} />)}
      </div>
    </div>
  </section>
);
